import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription, interval } from 'rxjs';
import { CloudTypes } from 'src/app/core/models/globals';
import { ShowOutput } from 'src/app/core/models/showOutput';
import { DeploymentService } from 'src/app/core/services/deployment.service';
import { EnvironmentService } from 'src/app/core/services/environment.service';
import { HeaderService } from 'src/app/core/services/header.service';
import { JobsService } from 'src/app/core/services/jobs.service';
import { StorageOracleService } from 'src/app/core/services/storage-oracle.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { SyncConfigService } from 'src/app/core/services/sync-config.service';
import { GoogleCloudService } from '../../../../../core/services/google-cloud.service';
import { JobConfirmationDialogComponent } from '../job-confirmation-dialog/job-confirmation-dialog.component';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { AwsCloudService } from '../../../../../core/services/aws-cloud.service';

@Component({
	selector: 'app-job-output-dialog',
	templateUrl: './job-output-dialog.component.html',
	styleUrls: ['./job-output-dialog.component.scss']
})
export class JobOutputDialogComponent implements OnInit {

	constructor(
		public dialogRef: MatDialogRef<JobOutputDialogComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: { depName: string; jobName: string; path: string; vmNodeName: string; id: string; depId: string; state: string},
		public jobService: JobsService,
		public dialog: MatDialog,
		private _headerService: HeaderService,
		private storageService: StorageService,
		private awsService: AwsCloudService,
		private spinner: NgxSpinnerService,
		private myElement: ElementRef, private depService: DeploymentService,
		private syncConfig: SyncConfigService, private _oracleService: StorageOracleService,
		private _googleService: GoogleCloudService, private env: EnvironmentService ) { }

	response: ShowOutput;
	jobFileName: string;
	jobOutputData: string;
	regexCode: string = 'gi';
	isSensitiveTitle: string = 'case-insensitive';
	jobOutput: string = ' ';
	depName = this.data.depName;
	vmNodeName;
	searchTerm: string;
	totalWordCount: number = 0;
	curvalue: number = 0;
	currentWordIndex: number = 0;
	totalElements: number;
	findExppr;
	trimmedFileName;
	startIdx;
	isSensitive: boolean = false;
	autoScroll: boolean = false;
	disableScrollDown: boolean = false;
	contentEditable: boolean = false;
	toShowPipe: boolean = false;
	disabled: boolean = true;
	toShow: boolean = false;
	dataCheckSubs: Subscription;
	loadDataSub: Subscription;
	toggleDialog: boolean = false;
	trimIndex: number = 400;
	dataEmpty: boolean = false;
	manualDisable: boolean = false;
	toggleFullScreen: boolean = false;
	cloudType = this._headerService.getCloudNameForDeployment(this.data.depName);
	toShowPaginator = this.cloudType == CloudTypes.OnPremise && !this.data?.depId && !this.data?.jobName;
	totalFileLines = -1;
	linePerPage = 1000;
	currentPageIndex = -1;
	pageLineOptions = [1000, 2000, 3000];
	hidePageSize = false;
	showPageSizeOptions = false;
	showFirstLastButtons = true;
	pageEvent: PageEvent;
	lastScrollHeight: number;
	@ViewChild("paginator", { static: true }) paginator: MatPaginator;
	@ViewChild('outputFileName') outputFileName;
	@ViewChild("editedFile") EditedFile;

	ngOnInit() {
		try {
			this.spinner.show();
			if (this.data.path.length > 75) {
				if (this.data.path.length > 110) {
					this.startIdx = this.data.path.length - 75
				} else {
					this.startIdx = 25
				}
				this.trimmedFileName = '...' + this.data.path.substring(this.startIdx, this.data.path.length)
			} else {
				this.trimmedFileName = this.data.path;
			}
			this.jobFileName = this.data.path;
			if(this.paginator?._intl)this.paginator._intl.itemsPerPageLabel = 'Lines per page:';
			this.loadOutputData();
		} catch (e) {
		}
	}

	ngOnDestroy() {
		if (this.dataCheckSubs) this.dataCheckSubs.unsubscribe();
		if (this.loadDataSub) this.loadDataSub.unsubscribe();
	}

	@ViewChild('scrollMe') private myScrollContainer: ElementRef;
	ngAfterViewChecked() {
		if (this.autoScroll) {
			this.scrollToBottom();
			this.autoScroll = false;
		}
	}

	private scrollToBottom(): void {
		try {
			if(this.lastScrollHeight == undefined){
				this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
				this.lastScrollHeight = this.myScrollContainer.nativeElement.scrollTop;
			} else {
				if(this.lastScrollHeight <= this.myScrollContainer.nativeElement.scrollTop) {
					this.lastScrollHeight = this.myScrollContainer.nativeElement.scrollTop;
					this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
				}
			}
		} catch (err) { }
	}

	loadOutputData() {
		if(this.data.depId){
			this.depService.getDeploymentStatus(this.depName, this.data.depId)
			.subscribe({
				next: (data) => {
					this.spinner.hide();	
					if(!data){
						this.dataEmpty = true;
						return;
					}
					this.jobOutput = JSON.parse(JSON.stringify(data))
					this.toShowPipe = true;
					this.dataEmpty = false;
					if (this.autoScroll == false) this.autoScroll = true;
				}, error: (err) => {
					this.dataEmpty = true;
					this.spinner.hide();
				}
			})
		} else {
			if (this.data.jobName) {
				if (this.cloudType == CloudTypes.Oracle && this.data?.state == "Inactive") {
					this._oracleService.viewFileData(this._headerService.getStorageNameForDeployment(this.data.depName), this.data.path).subscribe({
						next: data => {
							this.manageOutputData(data);
						},
						error: err => {
							this.spinner.hide();
							this.jobOutput = "Some error occurred... Please try again!";
							this.jobFileName = this.data.path;
						},
					});
				}
				else if (this.cloudType == CloudTypes.Google && this.data?.state == "Inactive") {
						this._googleService.viewFileData(this.data.depName, this._headerService.getStorageNameForDeployment(this.data.depName), this.data.path).subscribe({
								next: (data) => {
										this.manageOutputData(data);
								}, error: (err) => {
										this.spinner.hide();
										this.jobOutput = 'Some error occurred... Please try again!';
										this.jobFileName = this.data.path;
								}
						})
				}
				else if (this.cloudType == CloudTypes.AWS && this.data?.state == "Inactive") {
					this.awsService.viewFileData(this.data.depName, this._headerService.getStorageNameForDeployment(this.data.depName), this.data.path).subscribe({
						next: (data) => {
							this.manageOutputData(data);
						}, error: (err) => {
							this.spinner.hide();
							this.jobOutput = 'Some error occurred... Please try again!';
							this.jobFileName = this.data.path;
						}
					})
				}
				else {
					this.loadDataSub = this.jobService
						.viewJobOutput(
							this.data.depName,
							this.data.jobName
						)
						.subscribe({
							next: (data) => {
								this.response = <ShowOutput>JSON.parse(JSON.stringify(data));
								if (this.response.outputFile.length > 75) {
									if (this.response.outputFile.length > 110) {
										this.startIdx = this.response.outputFile.length - 75
									} else {
										this.startIdx = 25
									}
									this.trimmedFileName = '...' + this.response.outputFile.substring(this.startIdx, this.response.outputFile.length)
								} else {
									this.trimmedFileName = this.response.outputFile;
								}
								this.jobFileName = this.response.outputFile;
								this.jobOutput = this.response.jobOutput;
								this.toShowPipe = true;
								this.searchKeyword(this.searchTerm);
								if (this.autoScroll == false) this.autoScroll = true;
								this.spinner.hide();
							}, error: (error) => {
								this.spinner.hide();
								this.trimmedFileName = "Not Found"
							}
						})
				}
			}
			else {
				if(this.cloudType == CloudTypes.Oracle && !this.data.path.includes(this.env.envVariables.workStoreRoute)){
					this._oracleService.viewFileData(this._headerService.getStorageNameForDeployment(this.data.depName), this.data.path).subscribe({
						next: (data) => {
							this.manageOutputData(data);
						}, error: (err) => {
							this.spinner.hide();
							this.jobOutput = 'Some error occurred... Please try again!';
							this.jobFileName = this.data.path;
						}
					})
				}
				else if (this.cloudType == CloudTypes.Google && !this.data.path.includes(this.env.envVariables.workStoreRoute)) {
					this._googleService.viewFileData(this.data.depName, this._headerService.getStorageNameForDeployment(this.data.depName), this.data.path).subscribe({
						next: (data) => {
							this.manageOutputData(data);
						}, error: (err) => {
							this.spinner.hide();
							this.jobOutput = 'Some error occurred... Please try again!';
							this.jobFileName = this.data.path;
						}
					})
				}
				else if (this.cloudType == CloudTypes.AWS && !this.data.path.includes(this.env.envVariables.workStoreRoute)) {
					this.awsService.viewFileData(this.data.depName, this._headerService.getStorageNameForDeployment(this.data.depName), this.data.path).subscribe({
						next: (data) => {
							this.manageOutputData(data);
						}, error: (err) => {
							this.spinner.hide();
							this.jobOutput = 'Some error occurred... Please try again!';
							this.jobFileName = this.data.path;
						}
					})
				}
				else {
					let pageData = {
						totalLines: this.totalFileLines,
						pageSize: this.linePerPage,
						currentIndex: this.currentPageIndex,
					}
					this.loadDataSub = this.storageService.viewFileData(this.data.depName, this.data.path, this.data.vmNodeName, pageData).subscribe({
						next: (op: any) => {
							this.totalFileLines = op.FileLines;
							if(!op.FileData){
								op.FileData = "Either file is empty or node is inactive.";
							}
							if(this.currentPageIndex == -1){
								this.currentPageIndex = Math.floor(this.totalFileLines / this.linePerPage);
							}
							this.manageOutputData(op.FileData);
						},
						error: error => {
							this.spinner.hide();
							this.jobOutput = "Some error occurred... Please try again!";
							this.jobFileName = this.data.path;
						},
					});
				}
			}
		}
		this.toShow = true;
	}

	manageOutputData(op){
		if (this.data.path.length > 75) {
			if (this.data.path.length > 110) {
				this.startIdx = this.data.path.length - 75
			} else {
				this.startIdx = 25
			}
			this.trimmedFileName = '...' + this.data.path.substring(this.startIdx, this.data.path.length)
		} else {
			this.trimmedFileName = this.data.path;
		}
		this.jobFileName = this.data.path;
		if (op != null) {
			this.jobOutput = op.toString();
		}
		this.toShowPipe = true;
		this.searchKeyword(this.searchTerm);
		this.spinner.hide();
		if (this.autoScroll == false) this.autoScroll = true;
	}

	manualRefresh() {
		this.manualDisable = true;
		// if(this.loadDataSub) this.loadDataSub.unsubscribe()
		setTimeout(() => {
			this.manualDisable = false;
		}, 7000);
		this.loadOutputData();
	}

	autoRefresh() {
		this.disabled = false;
		this.loadOutputData();
		this.dataCheckSubs = interval(this.syncConfig.config.jobs.outputReqInterval).subscribe(() => {
			this.loadOutputData();
		});
	}

	pause() {
		this.disabled = true;
		this.autoScroll = false;
		this.dataCheckSubs.unsubscribe();
		if (this.loadDataSub) this.loadDataSub.unsubscribe();
	}

	onCancel() {
		if (this.contentEditable == true) {
			this.dialog.open(JobConfirmationDialogComponent, {
				width: '30%',
				height: '25%',
				autoFocus: true,
				disableClose: true,
				data: {
					actionValue: 51,
					title: 'Save File ',
					message: 'All changes will be lost, do you want to continue?',
					noBtnText: 'No',
					yesBtnText: 'Yes',
				},
			})
				.afterClosed()
				.subscribe(res => {
					if (res.data == 'Yes') {
						this.spinner.hide();
						if (this.dataCheckSubs) this.dataCheckSubs.unsubscribe();
						if (this.loadDataSub) this.loadDataSub.unsubscribe();
						this.dialogRef.close()
					}
				});
		} else {
			this.spinner.hide();
			if (this.dataCheckSubs) this.dataCheckSubs.unsubscribe();
			if (this.loadDataSub) this.loadDataSub.unsubscribe();
			this.dialogRef.close();
		}
	}

	onEdit() {
		this.contentEditable = true;
		this.autoScroll = false;
		if (this.loadDataSub) this.loadDataSub.unsubscribe();
	}

	onSave() {
		this.dialog.open(JobConfirmationDialogComponent, {
			width: '30%',
			height: '25%',
			autoFocus: true,
			disableClose: true,
			data: {
				actionValue: 51,
				title: 'Save File ',
				message: 'Do you want to save the changes ?',
				noBtnText: 'No',
				yesBtnText: 'Yes',
			},
		})
			.afterClosed()
			.subscribe(res => {
				if (res.data) {
					this.contentEditable = false;
					let newJobOutput = this.EditedFile.nativeElement.innerHTML;
					this.jobOutput = newJobOutput;
				}
			});
	}

	searchKeyword(value: string) {
		this.searchTerm = value
		if (this.searchTerm == undefined || this.searchTerm.length == 1 && this.searchTerm == '.') {
		} else {
			if (this.searchTerm == '' || this.searchTerm == undefined) {
				this.clearSearch()
			} else {
				this.findExppr = new RegExp(value, this.regexCode)
				this.totalWordCount = (this.jobOutput.match(this.findExppr) || []).length
				this.autoScroll = false;
			}
			if (this.totalWordCount != 0 && this.currentWordIndex == 0) {
				this.currentWordIndex = 1;
			}
			if (this.totalWordCount == 0) {
				this.currentWordIndex = 0;
			}
		}
	}

	makeCaseSensitive() {
		this.isSensitive = !this.isSensitive;
		this.autoScroll = false;
		if (this.isSensitive == true) {
			this.regexCode = 'g'
			this.isSensitiveTitle = 'case-sensitive'
		} else {
			this.regexCode = 'gi'
			this.isSensitiveTitle = 'case-insensitive'
		}
		this.jobOutput = this.jobOutput + ''
		this.searchKeyword(this.searchTerm)
	}

	clearSearch() {
		const dom: HTMLElement = this.myElement.nativeElement;
		dom.querySelectorAll('.marked').forEach(mark => {
			mark.setAttribute("style", "background-color: ''")
		})
		this.searchTerm = '';
		this.totalWordCount = 0;
		this.curvalue = 0;
		this.currentWordIndex = 0
		this.regexCode = 'gi'
		this.isSensitive = false;
		this.autoScroll = false;
	}

	removeAttrStyle(dom) {
		dom.querySelectorAll('.marked')[this.curvalue].setAttribute("style", "background-color: #fcf8e3")
	}

	findNext() {
		this.autoScroll = false;
		const dom: HTMLElement = this.myElement.nativeElement;
		this.removeAttrStyle(dom)
		this.curvalue = this.curvalue + 1;
		this.currentWordIndex = this.currentWordIndex + 1
		if (this.curvalue == this.totalWordCount) {
			this.curvalue = 0
			this.currentWordIndex = this.curvalue + 1
		}
		this.totalElements = dom.querySelectorAll('.marked').length
		dom.querySelectorAll('.marked')[this.curvalue].setAttribute("style", "background-color: #ff0;");
		dom.querySelectorAll(".marked")[this.curvalue].scrollIntoView({
			behavior: 'auto',
			block: 'center',
			inline: 'center'
		});
	}

	findPrevious() {
		this.autoScroll = false;
		const dom: HTMLElement = this.myElement.nativeElement;
		this.removeAttrStyle(dom)
		this.curvalue = this.curvalue - 1;
		this.currentWordIndex = this.currentWordIndex - 1
		if (this.currentWordIndex == 0) {
			this.curvalue = this.totalWordCount - 1
			this.currentWordIndex = this.totalWordCount;
		}
		this.totalElements = dom.querySelectorAll('.marked').length
		dom.querySelectorAll('.marked')[this.curvalue].setAttribute("style", "background-color: #ff0");
		dom.querySelectorAll(".marked")[this.curvalue].scrollIntoView();
	}

	toggleDialogMinMax(){
		if(this.toggleFullScreen && !this.toggleDialog) { this.onFullScreen() }
		let element = document.getElementById(this.data.id);
		let outputSpinner:HTMLElement = document.getElementById('jobOutputSpinner');
    
		const currentElement = this.myElement.nativeElement;
		
		let dialogElement = currentElement.parentElement;
		while (dialogElement && !dialogElement.classList.contains('cdk-overlay-pane')) {
			dialogElement = dialogElement.parentElement;
		}
		
		if (!dialogElement) {
			console.error('Could not find parent overlay pane');
			return;
		}

		if(!this.toggleDialog) {
			dialogElement.classList.add('minimize2');
			dialogElement.classList.remove('maximize');
			outputSpinner.style.visibility = 'hidden';
			this.trimIndex = 25
		} else {
			dialogElement.classList.remove('minimize2');
			dialogElement.classList.add('maximize');
			outputSpinner.style.visibility = 'visible';
			this.trimIndex = 50
			
			setTimeout(() => {
				dialogElement.classList.remove('maximize');
			}, 300);
		}
		this.toggleDialog = !this.toggleDialog;
	}

	onFullScreen(){
		if(this.toggleDialog){ this.toggleDialogMinMax() }
		let element = document.querySelector('.custom-output-dialog-container');
		if(!this.toggleFullScreen){
			element.classList.add('fullScreen');
		} else {
			element.classList.remove('fullScreen');
		}
		this.toggleFullScreen = !this.toggleFullScreen;
	}

	handlePageEvent(e: PageEvent) {
		this.spinner.show();
		this.pageEvent = e;
		this.totalFileLines = e.length;
		this.linePerPage = e.pageSize;
		this.currentPageIndex = e.pageIndex;
		this.loadOutputData();
	}

	setPageSizeOptions(setPageSizeOptionsInput: string) {
		if (setPageSizeOptionsInput) {
			this.pageLineOptions = setPageSizeOptionsInput.split(',').map(str => +str);
		}
	}
}
